import Utils from '../../framework/utils.js';
import Model from '../../framework/model.js';

const defaults = {
  itemsPerPage: 10,
  totalItems: 0,
  currentPage: 1
}

// PaginationModel
// ===============
//
// Provides basic state management for a pagination component

class PaginationModel extends Model {
  constructor(data = {}) {
    super({ data: data, defaults: defaults });
    Utils.bindMethods(this, ['onChange']);
    this.addEventListener('Model.Change', this.onChange)
  }

  getCurrentPage() {
    return this.get('currentPage');
  }

  getPageCount() {
    return Math.ceil(this.get('totalItems') / this.get('itemsPerPage'));
  }

  // `getCurrentRange()`
  //
  // Returns the result range of the current page

  getCurrentRange() {
    let start = this.get('itemsPerPage') * Math.max(0, this.get('currentPage') - 1);
    let end = Math.min(this.get('totalItems'), start + this.get('itemsPerPage'));
    return {
      start: start,
      end: end
    }
  }

  reset() {
    // Resets the current page and forces the change event in case the current page was already 1.
    this.set('currentPage', 1, true)
  }

  nextPage() {
    this.set('currentPage', Math.min(this.get('currentPage') + 1, this.getPageCount()))
  }

  previousPage() {
    this.set('currentPage', Math.max(this.get('currentPage') - 1, 1));
  }

  firstPage() {
    this.set('currentPage', 1);
  }

  lastPage() {
    this.set('currentPage', this.getPageCount());
  }

  onChange(evt) {
    if (evt.data.path == 'totalItems') {
      // if the total number of items changes, then we reset the state
      this.reset();
    }
  }
}

export default PaginationModel;